module.exports = __webpack_public_path__ + "img/[胜利].69e067e7.svg";